import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { NewMainAppPromotionNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { setTrackingId } from "client/Misc/utils";

export type NewMainAppPromotionActivityProps = {
	data: NewMainAppPromotionNotificationDataViewModel;
};

export const NewMainAppPromotionActivity = (props: NewMainAppPromotionActivityProps): ReactElement => {
	const {
		data
	} = props;

	const {
		name
	} = data;

	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={localize("_AppNameIsNowAvailableClickHereToOpenTheAppStore")}
				thingsToReplace={[
					{
						what: "{{AppName}}",
						filler: (
							<Typography
								trackingId="app-name"
								weight="bold"
							>
								{name}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};

NewMainAppPromotionActivity.displayName = "NewMainAppPromotionActivity";